import React, { useState, useEffect } from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import ParticipantSidebar from "./Sidebar";
import { useAuth } from "../../../context/AuthContext";
import logo from "../../../assets/access-lg-logo.png";
import { FiAlignJustify, FiBell } from "react-icons/fi";
import { MdKeyboardArrowLeft } from "react-icons/md";

const ParticipantLayout = () => {
  const { user } = useAuth();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const getDisplayName = () => {
    if (user?.name) return user.name;
    if (user?.displayName) return user.displayName;
    if (user?.user?.firstName || user?.user?.lastName) {
      return `${user?.user?.firstName || ""} ${user?.user?.lastName || ""}`.trim();
    }
    return "Participant";
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      setSidebarOpen(window.innerWidth > 768);
    }
  }, []);

  useEffect(() => {
    if (window.innerWidth <= 768) {
      setSidebarOpen(false);
    }
  }, [location.pathname]);

  const toggleSidebar = () => {
    setSidebarOpen((state) => !state);
  };

  const initials = getDisplayName()?.slice(0, 1)?.toUpperCase();

  return (
    <main className="h-screen flex flex-col bg-[#F8F8F8]">
      <header className="border-b border-gray-100 w-full justify-between p-4 items-center shadow-md bg-white">
        <div className="flex w-full items-center justify-between">
          <button
            type="button"
            className="md:hidden block border border-gray-200 rounded-md p-2"
            onClick={toggleSidebar}
          >
            <FiAlignJustify className="w-4 h-4" />
          </button>

          <Link to="/participant/dashboard" className="ml-2 md:ml-0">
            <img src={logo} alt="logo" className="w-[150px] h-[36px] object-contain" />
          </Link>

          <div className="flex items-center justify-end gap-4">
            <button type="button" className="hidden md:flex relative bg-white rounded-full p-2 border border-gray-100">
              <FiBell className="w-4 h-4" />
            </button>
            <Link to="/participant/profile" className="h-[40px] w-[40px] border-4 border-white bg-[#0A3059] text-white rounded-full flex items-center justify-center text-sm font-semibold">
              {initials}
            </Link>
          </div>
        </div>
      </header>

      <div className="w-full relative grow flex flex-col md:flex-row overflow-hidden">
        <ParticipantSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        <div className="w-full relative grow flex flex-col overflow-hidden">
          <button
            type="button"
            onClick={toggleSidebar}
            className="hidden md:flex absolute rounded-tl-none rounded-bl-none rounded-tr-3xl rounded-br-3xl left-0 top-2 bg-[#0A3059] p-2 text-white"
          >
            <MdKeyboardArrowLeft className={`w-5 h-5 transition-all duration-200 ${sidebarOpen ? "rotate-0" : "rotate-180"}`} />
          </button>
          <div className="w-full grow overflow-y-auto p-5 md:pt-10 md:px-10">
            <Outlet />
          </div>
        </div>
      </div>
    </main>
  );
};

export default ParticipantLayout;
